<template>
  <div class="common-container">
    <div class="content">
      <div class="logo"><el-image :src="require('@/assets/layout/logo.png')"></el-image></div>
      <div class="o-title">
        <div class="box"></div>
        {{
          ['校准/检定证书查询结果如下：', '检测报告查询结果如下：', '认证/证书查询结果如下：', '荣誉证书查询结果如下：', '产品正品防伪查询结果如下：'][detail.classifyId - 1]
        }}
      </div>
      <!--<div class="s-title">查询结果如下：</div>-->
      <div class="c-table">
        <inquiry-result-table :data="detail" :show-operate="false" from="mobile"/>
      </div>
      <div class="bottom">
        <div class="b-top" @click="openWebsite">技术支持：{{ websiteConfig.technicalSupport }} <i class="el-icon-paperclip"></i></div>
        <div class="b-bottom"><a :href="'tel:'+websiteConfig.customerServicePhone">{{ websiteConfig.customerServicePhone }}</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import InquiryResultTable from "../components/ResultTable.vue";
import {getWebsiteConfig} from "@/utils/website-config";

export default {
  name: "InquiryResult",
  components: {InquiryResultTable},
  data() {
    return {
      detail: {},
      sign: process.env.VUE_APP_API_BASE_URL.substring(0, process.env.VUE_APP_API_BASE_URL.lastIndexOf('/')) + '/static/images/sign.png',
    }
  },
  created() {
    const inquiryId = this.$route.query.inquiryId;
    this.$request.get('/Inquiry/qrcodeResult', {
      params: {
        inquiryId
      }
    }).then(res => {
      if (res.code === 0) {
        this.detail = res.data
      }
    })
  },
  computed: {
    // 网站配置
    websiteConfig() {
      return getWebsiteConfig()
    }
  },
  methods: {
    /**
     * 打开网址
     */
    openWebsite() {
      location.replace('/');
    }
  }
}
</script>

<style lang="scss">
body {
  min-width: unset;

  .result-table .table {
    width: 100% !important;
    padding: 0 !important;

    .table-item {
      font-size: 12px !important;

      .title {
        width: 72px !important;
        line-height: 20px !important;
        padding: 10px !important;
      }

      .value {
        line-height: 20px !important;
        padding: 10px !important;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .logo {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-image {
      max-width: 350px;
      margin: 20px;
    }
  }
  .o-title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 10px 5px;

    .box {
      width: 5px;
      height: 16px;
      background-color: #000000;
      border-radius: 4px;
      margin-right: 5px;
    }
  }

  .s-title {
    font-size: 14px;
    width: 100%;
    padding: 0 5px 10px 5px;
    color: #2D2D2D;
  }

  .c-table {
    width: 100%;
    position: relative;

    .sign {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 200px;
      height: 200px;
      transform: translate(0, -50%);
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    align-items: center;
    font-size: 14px;
    color: #2D2D2D;

    .b-top {
      color: #1464ff;
      margin-bottom: 10px;
      font-weight: bold;
    }

    a {
      color: #2D2D2D;
      text-decoration: none;
    }
  }
}
</style>